import { combineReducers } from '@reduxjs/toolkit';
import { default as datapoints } from './datapoints';
import editedFamilyClusterDatapoints from './editedFamilyClusterDatapoints';
import pagination from './pagination';
import sort from './sort';
import totalElements from './totalElements';

const rootReducer = combineReducers({
  datapoints,
  pagination,
  totalElements,
  sort,
  editedFamilyClusterDatapoints,
});

export type GetFamilyClusterModalStateProps = ReturnType<typeof rootReducer>;

export default rootReducer;
